"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _propTypes = require("prop-types");

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _HelpOutline = _interopRequireDefault(require("@material-ui/icons/HelpOutline"));

var _form = require("@widergy/web-utils/lib/form");

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _formTypes = require("../../types/formTypes");

var _UTTooltip = _interopRequireDefault(require("../UTTooltip"));

var _WithTheme = _interopRequireDefault(require("../WithTheme"));

var _theme = require("./theme");

var _stylesJS = _interopRequireDefault(require("./stylesJS"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var VALUE_KEY = 'value';
var LABEL_KEY = 'name';
var MENU_TITLE = 'Seleccione una opción';
var MENU_TITLE_MULTIPLE = 'Seleccione una o más opciones';

var UTSelect = /*#__PURE__*/function (_PureComponent) {
  _inherits(UTSelect, _PureComponent);

  function UTSelect() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UTSelect);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UTSelect)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (event) {
      return _this.props.input.onChange(event.target.value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleRenderValue", function (valueKey, labelKey, options) {
      return function (selected) {
        var selectedOptions = options.filter(function (option) {
          return selected.includes(option[valueKey]);
        });
        return selectedOptions.map(function (selection) {
          return selection[labelKey];
        }).join(', ');
      };
    });

    return _this;
  }

  _createClass(UTSelect, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          options = _this$props.options,
          withOrder = _this$props.withOrder,
          labelKey = _this$props.labelKey,
          valueKey = _this$props.valueKey,
          menuPlaceholder = _this$props.menuPlaceholder,
          meta = _this$props.meta,
          input = _this$props.input,
          placeholder = _this$props.placeholder,
          disabled = _this$props.disabled,
          tooltip = _this$props.tooltip,
          classes = _this$props.classes,
          IconPlaceholder = _this$props.iconPlaceholder,
          field = _this$props.field;

      var sortedOptions = _toConsumableArray(options);

      sortedOptions = withOrder ? sortedOptions.sort(function (a, b) {
        return a.order < b.order ? -1 : 1;
      }) : sortedOptions;
      var value = valueKey || VALUE_KEY;
      var label = labelKey || LABEL_KEY;
      var isMultiple = field.configuration && field.configuration.multiple;

      var SelectInput = _react["default"].createElement(_FormControl["default"], {
        className: classes.container,
        error: (0, _form.shouldShowErrors)(meta)
      }, _react["default"].createElement(_InputLabel["default"], null, IconPlaceholder ? _react["default"].createElement("div", {
        className: classes.labelContainer
      }, _react["default"].createElement(IconPlaceholder, {
        className: classes.labelIcon
      }), _react["default"].createElement("div", null, placeholder)) : placeholder), _react["default"].createElement(_Select["default"], {
        name: input.name,
        multiple: isMultiple,
        value: isMultiple ? input.value || [] : input.value,
        onChange: this.handleChange,
        disabled: disabled,
        renderValue: isMultiple && this.handleRenderValue(value, label, options)
      }, _react["default"].createElement(_MenuItem["default"], {
        value: "",
        disabled: isMultiple
      }, menuPlaceholder || (isMultiple ? MENU_TITLE_MULTIPLE : MENU_TITLE)), sortedOptions.map(function (option) {
        var OptionIcon = option.icon;
        return _react["default"].createElement(_MenuItem["default"], {
          key: option[value],
          value: option[value]
        }, isMultiple && _react["default"].createElement(_Checkbox["default"], {
          color: "primary",
          checked: input.value.indexOf(option[_this2.props.valueKey]) > -1
        }), OptionIcon ? _react["default"].createElement("div", {
          className: classes.labelContainer
        }, _react["default"].createElement(OptionIcon, {
          className: classes.optionIcon
        }), _react["default"].createElement("div", null, option[label])) : option[label]);
      })), (0, _form.shouldShowErrors)(this.props.meta) && _react["default"].createElement(_FormHelperText["default"], null, this.props.meta.error));

      return _react["default"].createElement("div", {
        className: classes.container
      }, tooltip ? _react["default"].createElement(_Grid["default"], {
        style: _stylesJS["default"].gridContainer,
        container: true,
        spacing: 1,
        alignItems: "flex-end"
      }, _react["default"].createElement(_Grid["default"], {
        item: true,
        xs: true
      }, SelectInput), _react["default"].createElement(_Grid["default"], {
        item: true,
        style: _stylesJS["default"].icon
      }, _react["default"].createElement(_UTTooltip["default"], {
        content: tooltip
      }, _react["default"].createElement("span", null, _react["default"].createElement(_HelpOutline["default"], {
        className: classes.tooltipIcon
      }))))) : SelectInput);
    }
  }]);

  return UTSelect;
}(_react.PureComponent);

UTSelect.defaultProps = {
  options: [],
  classes: {},
  field: {
    configuration: {
      multiple: false
    }
  }
};
UTSelect.propTypes = {
  input: _formTypes.inputPropTypes.isRequired,
  iconPlaceholder: _propTypes.node,
  meta: _formTypes.metaPropTypes.isRequired,
  disabled: _propTypes.bool,
  valueKey: _propTypes.string,
  labelKey: _propTypes.string,
  placeholder: _propTypes.string.isRequired,
  withOrder: _propTypes.bool,
  options: (0, _propTypes.arrayOf)((0, _propTypes.shape)({}).isRequired),
  tooltip: _propTypes.string,
  menuPlaceholder: _propTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  classes: _propTypes.any,
  // eslint-disable-next-line react/forbid-prop-types
  field: _propTypes.any
};

var _default = (0, _WithTheme["default"])(_theme.retrieveStyle, _theme.retrieveMuiTheme)(UTSelect);

exports["default"] = _default;